import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import {
  TracingWrapper,
  OrderInfoRow,
  OrderInfoLabel,
  OrderInfoValue,
  MapViewMainContainer,
  AnimatedIconContainer,
  RejectedIconBox,
  MapViewMainTitle,
  MapViewSubtitle,
  MapViewDescription,
  MapViewTitleDescriptionBox,
  MapViewReasonCard,
  MapViewSupportCard,
  MapViewOrderDetailsSection,
  MapViewSupportHeader,
  MapViewSupportList,
  MapViewSupportItem,
  MapViewReasonLabel,
  MapViewReasonText,
  MapViewSupportTitle,
  MapViewSupportDescription,
  MapViewSupportCaption,
  MapViewOrderDetailsTitle,
  MapViewOrderDetailsContainer
} from "layout/styles";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PhoneIcon from '@mui/icons-material/Phone';
import ReceiptIcon from '@mui/icons-material/Receipt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocationOnIcon from '@mui/icons-material/LocationOn';


const RejectedOrderView = ({ orderInfo = {} }) => {
  return (
    <TracingWrapper>
      <MapViewMainContainer>
        {/* Error Icon with Animation */}
        <AnimatedIconContainer>
          <RejectedIconBox>
            <ErrorOutlineIcon sx={{ 
              fontSize: 60, 
              color: 'white',
            }} />
          </RejectedIconBox>
        </AnimatedIconContainer>

        {/* Title and Main Message */}
        <MapViewTitleDescriptionBox>
          <MapViewMainTitle variant="h3">
            Order Rejected
          </MapViewMainTitle>
          
          <MapViewSubtitle variant="h6">
            We're sorry, but your order has been rejected
          </MapViewSubtitle>

          <MapViewDescription variant="body1">
            This could be due to restaurant capacity, item availability, or delivery restrictions
          </MapViewDescription>
        </MapViewTitleDescriptionBox>

        {/* Reason Card (if available) */}
        {orderInfo?.rejectedReason && (
          <MapViewReasonCard >
            <MapViewReasonLabel variant="subtitle2">
              Rejection Reason:
            </MapViewReasonLabel>
            <MapViewReasonText variant="body2">
              {orderInfo.rejectedReason}
            </MapViewReasonText>
          </MapViewReasonCard>
        )}

        {/* Support Information */}
        <MapViewSupportCard>
          <MapViewSupportHeader>
            <SupportAgentIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            <MapViewSupportTitle variant="subtitle2">
              Need Assistance?
            </MapViewSupportTitle>
          </MapViewSupportHeader>
          
          <MapViewSupportDescription variant="body2">
            Our support team is here to help you. You can try placing a new order or contact us for assistance.
          </MapViewSupportDescription>

          <MapViewSupportList>
            <MapViewSupportItem>
              <PhoneIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
              <MapViewSupportCaption variant="caption">
                24/7 Customer Support Available
              </MapViewSupportCaption>
            </MapViewSupportItem>
            <MapViewSupportItem>
              <RefreshIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
              <MapViewSupportCaption variant="caption">
                No charges applied for rejected orders
              </MapViewSupportCaption>
            </MapViewSupportItem>
          </MapViewSupportList>
        </MapViewSupportCard>

        {/* Order Details (if needed) */}
        {(orderInfo?.number || orderInfo?.companyName) && (
          <MapViewOrderDetailsSection>
            <MapViewOrderDetailsTitle variant="h6">
              Order Details
            </MapViewOrderDetailsTitle>
            
            <MapViewOrderDetailsContainer>
                {orderInfo?.number && (
                  <OrderInfoRow>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <ReceiptIcon sx={{ color: 'error.main', fontSize: 18 }} />
                      <OrderInfoLabel>Order Number</OrderInfoLabel>
                    </Box>
                    <OrderInfoValue data-type="order-number">
                      #{orderInfo.number}
                    </OrderInfoValue>
                  </OrderInfoRow>
                )}

                {orderInfo?.companyName && (
                  <>
                    <Divider sx={{ my: 0.5 }} />
                    <OrderInfoRow>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <StorefrontIcon sx={{ color: 'error.main', fontSize: 18 }} />
                        <OrderInfoLabel>Restaurant</OrderInfoLabel>
                      </Box>
                      <OrderInfoValue>
                        {orderInfo.companyName}
                      </OrderInfoValue>
                    </OrderInfoRow>
                  </>
                )}
                <Divider sx={{ my: 0.5 }} />
                <OrderInfoRow>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOnIcon sx={{ color: 'error.main', fontSize: 18 }} />
                  <OrderInfoLabel>Delivery Address</OrderInfoLabel>
                </Box>
                <OrderInfoValue sx={{ 
                  maxWidth: '300px',
                  fontSize: '16px'
                }}>
                  {orderInfo?.address || 'N/A'}
                </OrderInfoValue>
              </OrderInfoRow>
            </MapViewOrderDetailsContainer>
          </MapViewOrderDetailsSection>
        )}
      </MapViewMainContainer>
    </TracingWrapper>
  );
};

export default RejectedOrderView; 